import { useEffect, useRef, useState } from "react";
import { getThemeClass, getThemeComponentGroup } from "../lib/themeComponentClasses";

export const UserAvatarDropdown = ({ userName = "U", menuItems = [] }) => {
  const avatarClasses = getThemeComponentGroup("avatar");
  const menuClasses = getThemeComponentGroup("menu");
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      {/* Avatar */}
      <div
        onClick={() => setOpen(!open)}
        className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold cursor-pointer select-none ${getThemeClass(avatarClasses.badgeBgColor, "bg-theme-primary-alt")} ${getThemeClass(avatarClasses.badgeTextColor, "text-theme-text-inverse")}`}
      >
        {userName}
      </div>

      {/* Dropdown */}
      {open && (
        <div
          className={`absolute right-0 mt-2 w-44 shadow-lg rounded-md border z-90 ${getThemeClass(menuClasses.panelBgColor, "bg-theme-surface")} ${getThemeClass(menuClasses.panelBorderColor, "border-theme-border")}`}
        >
          <ul
            className={`text-sm ${getThemeClass(menuClasses.itemTextColor, "text-theme-text-muted")}`}
          >
            {menuItems.map((item, index) => (
              <li
                key={index}
                onClick={() => {
                  item.onClick?.();
                  setOpen(false);
                }}
                className={`px-4 py-3 cursor-pointer ${getThemeClass(menuClasses.itemHoverBgColor, "hover:bg-theme-surface-soft")} ${
                  item.danger ? "text-theme-danger hover:bg-theme-danger-bright-soft" : ""
                }`}
              >
                {item.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
